import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class FlagWindowWarning extends Component {
  render() {
    return (
      <div className="itemProduct">
        <div className="flaggedWindow">
          <h5>Expert Help Required</h5>
          <h3>Please call <a href={`tel:${this.props.phoneNumber}`}>{this.props.phoneNumber}</a>.</h3>
          <p>{this.props.flaggedWindowText}</p>
        </div>
      </div>
    );
  }
}

FlagWindowWarning.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  flaggedWindowText: PropTypes.string.isRequired,
};

export default FlagWindowWarning;
